import React from "react";
import { Stack, Typography } from "@mui/material";

import { RoutePaths } from "src/app/model";
import { ServicesCards } from "src/widgets/ServicesCards";

export const ServicesPage: React.FC = () => {
  return (
    <Stack
      id={RoutePaths.SERVICES}
      width={1}
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={2}
      sx={{
        scrollMarginTop: 80,
      }}
    >
      <Typography
        color="text.secondary"
        variant="h5"
        fontWeight="light"
        sx={{
          opacity: 0.8,
          fontSize: { sm: "1.5rem", xs: "1rem" },
        }}
      >
        OUR SERVICES
      </Typography>

      <Stack
        direction="row"
        gap={1}
        borderBottom={1}
        borderColor="primary.main"
      >
        <Typography
          color="text.secondary"
          variant="h3"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "3rem",
              md: "2.75rem",
              sm: "2.5rem",
              xs: "2rem",
            },
          }}
        >
          What We
        </Typography>
        <Typography
          color="primary"
          variant="h3"
          fontWeight={300}
          sx={{
            fontSize: {
              lg: "3rem",
              md: "2.75rem",
              sm: "2.5rem",
              xs: "2rem",
            },
          }}
        >
          Do.
        </Typography>
      </Stack>

      <Typography
        color="text.primary"
        variant="body1"
        maxWidth="50%"
        textAlign="center"
        sx={{
          maxWidth: {
            lg: 0.5,
            md: 0.7,
            sm: 0.8,
            xs: 0.9,
          },
        }}
      >
        Solving complex, mission-critical generative AI problems for large
        German B2B corporations (DAX and Mittelstand), particularly for leaders
        of AI initiatives who have experienced previous setbacks and are under
        immense pressure to deliver tangible results.
      </Typography>

      <ServicesCards />
    </Stack>
  );
};
